import { useEffect } from "react";

import { DEFAULT_BREAKPOINT_WIDTH } from "./useIsMobile";

const isMobileViewport = () => window.innerWidth < DEFAULT_BREAKPOINT_WIDTH;

/**
 * Locks document scroll (iOS-safe) while `enabled` is true on mobile viewports.
 */
const useScrollLock = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return;

    let scrollY = 0;
    let isLocked = false;
    const { style } = document.body;
    const previous = {
      overflow: style.overflow,
      position: style.position,
      top: style.top,
      width: style.width,
    };

    const lock = () => {
      if (isLocked) return;

      scrollY = window.scrollY;
      style.overflow = "hidden";
      style.position = "fixed";
      style.top = `-${scrollY}px`;
      style.width = "100%";
      isLocked = true;
    };

    const unlock = () => {
      if (!isLocked) return;

      style.overflow = previous.overflow;
      style.position = previous.position;
      style.top = previous.top;
      style.width = previous.width;
      window.scrollTo(0, scrollY);
      isLocked = false;
    };

    const syncLockState = () => {
      if (isMobileViewport()) {
        lock();
      } else {
        unlock();
      }
    };

    syncLockState();
    window.addEventListener("resize", syncLockState);

    return () => {
      window.removeEventListener("resize", syncLockState);
      unlock();
    };
  }, [enabled]);
};

export default useScrollLock;
